import { useState } from 'react';
import { FormLayout, TextField, Button, BlockStack } from '@shopify/polaris';

export interface CostFormValues {
  cost_amount: string;
  supplier: string;
  batch_ref: string;
  quantity: string;
  effective_date: string;
  notes: string;
}

const EMPTY: CostFormValues = {
  cost_amount: '',
  supplier: '',
  batch_ref: '',
  quantity: '',
  effective_date: new Date().toISOString().slice(0, 10),
  notes: '',
};

/**
 * Product cost input form (single entry / new batch). PLAN.md §7.2.
 */
export default function CostForm({
  onSubmit,
  saving = false,
}: {
  onSubmit: (values: CostFormValues) => void;
  saving?: boolean;
}) {
  const [values, setValues] = useState<CostFormValues>(EMPTY);

  const set = (key: keyof CostFormValues) => (value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  return (
    <BlockStack gap="400">
      <FormLayout>
        <FormLayout.Group>
          <TextField
            label="Unit cost"
            type="number"
            prefix="$"
            value={values.cost_amount}
            onChange={set('cost_amount')}
            autoComplete="off"
            requiredIndicator
          />
          <TextField
            label="Quantity"
            type="number"
            value={values.quantity}
            onChange={set('quantity')}
            autoComplete="off"
          />
        </FormLayout.Group>
        <FormLayout.Group>
          <TextField
            label="Supplier"
            value={values.supplier}
            onChange={set('supplier')}
            autoComplete="off"
          />
          <TextField
            label="Batch reference"
            value={values.batch_ref}
            onChange={set('batch_ref')}
            autoComplete="off"
          />
        </FormLayout.Group>
        <TextField
          label="Effective date"
          type="date"
          value={values.effective_date}
          onChange={set('effective_date')}
          autoComplete="off"
          helpText="Cost applies to orders on or after this date (FIFO lookup)."
        />
        <TextField
          label="Notes"
          value={values.notes}
          onChange={set('notes')}
          multiline={2}
          autoComplete="off"
        />
      </FormLayout>
      <Button variant="primary" onClick={() => onSubmit(values)} loading={saving}>
        Save cost
      </Button>
    </BlockStack>
  );
}
